import { createContext, useContext } from 'react';

export type RequirementReviewInput = {
  type: 'requirement_review';
  card_id: string;
  revision: string;
  decision: 'confirmed' | 'rejected';
  answers: {
    question_id: string;
    selected_keys: string[];
    other?: string;
  }[];
};

export type QuestionCardInput = {
  conversationId: string | null;
  isStreaming: boolean;
  isLoadingConversation: boolean;
  send: (
    message: string,
    input: RequirementReviewInput,
    conversationId: string
  ) => Promise<{ ok: boolean; aborted?: boolean }> | void;
};

/** A card answer travels with its immutable identity, outside user-facing text. */
export const QuestionCardInputContext = createContext<QuestionCardInput | null>(
  null
);

export const useQuestionCardInput = () => useContext(QuestionCardInputContext);
